import React from 'react';
import styled from 'styled-components';

import { getEventPriceRange, getTicketStatus } from '@src/utils/event';
import { CURRENCY_SYMBOL } from '@src/const/common';
import {
	HostBy,
	PriceRange,
} from '@src/components/card/style';
import InfoByStatus from '@src/components/card/infoByStatus';
import { LargeCard as BasicLargeCard } from '@src/components/card/basic';
import { getPrice } from '@src/components/card/utils';

import TagContent from './tagContent';

const StyledInfoByStatus = styled(InfoByStatus)`
	font-size: 16px;
`;

const StyledHostBy = styled(HostBy)`
	margin-top: 12px;
	font-size: 16px;
`;

const StyledPriceRange = styled(PriceRange)`
	margin-top: 18px;
	color: ${props => props.theme.colors.primary};

	.price-range__number {
		font-size: 28px;
		font-weight: 500;
	}
`;

interface IProps {
	onClick?: () => void;
	webinar: any;
}

const LargeCard = ({
	onClick,
	webinar,
}: IProps): JSX.Element => {
	const {
		name: title,
		host_by: hostBy,
		photos,
		slots,
	} = webinar;
	const photoLinks = photos.map(photo => photo.link);
	const { status, countDownTime } = getTicketStatus({ slots });
	let price = { minPrice: 0, maxPrice: 0 };
	if (slots.length) {
		price = getEventPriceRange(slots);
	}
	const { minPrice, maxPrice } = price;
	const isFree = (minPrice === maxPrice) && minPrice === 0;

	return (
		<BasicLargeCard
			onClick={onClick}
			title={title}
			tagText={<TagContent />}
			tagColor="#FFFFFF"
			tagBorderColor="#DDDDDD"
			imageUrl={photoLinks[0]}
			imageAlt={photos[0]?.alt_title}
			contentElem={(
				<>
					<StyledHostBy>{hostBy}</StyledHostBy>
					<StyledInfoByStatus status={status} countDownTime={countDownTime} slots={slots} />
					<StyledPriceRange>
						{!isFree && <span className="price-range__currency">{CURRENCY_SYMBOL}</span>}
						<span className="price-range__number">
							{getPrice({ minPrice, maxPrice })}
						</span>
					</StyledPriceRange>
				</>
			)}
		/>
	);
};

export default LargeCard;
